import {
  IonPage,
  IonButton,
  IonButtons,
  IonIcon,
  IonHeader,
  IonTitle,
  IonToolbar,
  useIonViewDidEnter,
} from '@ionic/react'
import React, { BaseSyntheticEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { chevronBackOutline } from 'ionicons/icons'
import PCRHeader from '../../../components/pcrHeader/PCRHeader.component'
import { IRootState } from '../../../store'
import './CompleteChart.page.css'
import { AppRouterConstants } from '../../../components/appRouter/AppRouter.constants'
import { resetPCR } from '../../home/store/home.actions'
import { clearLocalNotifications } from '../../../utilities/localNotifications.util'
import { runAllRules, setIsLoading } from '../../rules/store/rules.actions'
import useDeviceMetrics from '../../../utilities/useDeviceMetrics'
import CompleteChartTablet from './completeChartTablet/CompleteChartTablet.component'
import CompleteChartMobile from './completeChartMobile/CompleteChartMobile.component'
import { calculateBillingCMSValue } from '../store/completeChart.actions'

const CompleteChart: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const { isTablet } = useDeviceMetrics()
  const submitChartState = useSelector((state: IRootState) => state.submitChart)
  const { success } = submitChartState

  useIonViewDidEnter(() => {
    dispatch(calculateBillingCMSValue())
    dispatch(setIsLoading(true))
    dispatch(runAllRules())
  })

  const onBackClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    dispatch(resetPCR())
    clearLocalNotifications()
    history.push(AppRouterConstants.HOME_ROUTE)
  }

  return (
    <IonPage id='CompleteChartPage' data-testid='CompleteChart'>
      <PCRHeader />
      <IonHeader className='ion-no-padding'>
        <IonToolbar color='light'>
          {success && (
            <IonButtons slot='start'>
              <IonButton data-testid='Back' fill='clear' onClick={onBackClick} color='primary'>
                <IonIcon icon={chevronBackOutline} />
                {t('common.buttons.Back')}
              </IonButton>
            </IonButtons>
          )}
          <IonTitle>{t('completeChart.completeChart')}</IonTitle>
        </IonToolbar>
      </IonHeader>
      {isTablet ? <CompleteChartTablet /> : <CompleteChartMobile />}
    </IonPage>
  )
}

export default CompleteChart
